<script lang="ts">
	import PosterText from 'component/PosterText.svelte'
	import { dev_mode, storefront_prefix } from 'shared/var'

	export let poster: {
		name: string
		hide_name: boolean | undefined
		href: string
		thumbnail_url: string | undefined // deprecated but probably still in use somewhere
		desktop_image_src: string | undefined
		mobile_image_src: string | undefined
		mux_playback_id: string | undefined
		thumbnail_timecode_seconds: number | undefined
		new: boolean | undefined
	}

	const mux_image_src = poster.mux_playback_id && `https://image.mux.com/${ poster.mux_playback_id }/thumbnail.jpg?time=${ poster.thumbnail_timecode_seconds }`

	const desktop_image_src = mux_image_src || poster.desktop_image_src || poster.thumbnail_url
	const mobile_image_src = mux_image_src || poster.mobile_image_src || desktop_image_src

	let { href } = poster
	if (dev_mode) {
		href = href.replace(`https://www.trex-arms.com`, storefront_prefix)
	}
</script>

<a {href} class="poster-tile" aria-label={poster.name}>
	<div class="background" style="--desktop-image-src: url({ desktop_image_src }); --mobile-image-src: url({ mobile_image_src })"></div>
	{#if !poster.hide_name}
		<PosterText>{poster.name}</PosterText>
	{/if}
	{#if poster.new}
		<div class="new">
			<PosterText>
				New
			</PosterText>
		</div>
	{/if}
</a>

<style>
	.poster-tile {
		font-size: var(--desktop-font-size);
		position: relative;
	}

	.poster-tile :global(.poster_text) {
		--background-color: transparent !important;
		align-items: center !important;
	}

	.poster-tile:hover :global(.poster_text) {
		--text-color: #ceff51;
		--background-color: black !important;
	}

	.background {
		padding-bottom: var(--desktop-padding-bottom);
		background-color: #000;
		background-image: var(--desktop-image-src);
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center;
	}

	.poster-tile .background {
		filter: saturate(1.2) brightness(0.8) contrast(0.8);
	}

	.poster-tile:hover .background {
		filter: saturate(1) brightness(1) contrast(1);
	}

	.new {
		--new-font-size: calc(var(--desktop-font-size) / 2);
		position: absolute;
		left: 1rem;
		top: 1rem;
		width: calc(var(--new-font-size) * 3);
		border: 2px solid #ceff51;
		border-radius: 5px;
		padding: calc(var(--new-font-size) * 0.75) 0rem;
	}

	.new :global(.poster_text) {
		--background-color: transparent !important;
		font-size: var(--new-font-size);
	}

	@media (max-width: 800px) {
		.poster-tile {
			font-size: var(--mobile-font-size);
		}

		.background {
			padding-bottom: var(--mobile-padding-bottom);
			background-image: var(--mobile-image-src);
		}

		.new {
			--new-font-size: calc(var(--mobile-font-size) / 2);
		}
	}
</style>
